import React from 'react'
import graphqlQuery from 'graphs/queries/UsersPaginated.graphql'
import withConnectionQuery from 'components/withConnectionQuery'
import fields from 'fields/users'
import companyUpdateMutation from 'graphs/mutations/updateCompany.graphql'
import CompanyPrimaryUser from 'graphs/queries/CompanyPrimaryUser.graphql'
import SelectBelongsTo from 'components/BelongsTo/Select'

const RoutePrimaryUserManage = ({
  company,
  match: { path },
  match,
  history,
  ...props
}) => (
  <SelectBelongsTo
    history={history}
    match={match}
    fields={fields}
    mutation={companyUpdateMutation}
    buildMutationOptions={row => ({
      variables: {
        id: company.id,
        data: { primary_user_id: row.id }
      },
      update: (store, { data }) =>
        store.writeQuery({
          query: CompanyPrimaryUser,
          variables: { company_id: company.id },
          data: { company: { ...company, primary_user: row } }
        })
    })}
    afterMutate={() => history.push(`${path.replace(/\/manage$/g, '')}`)}
    {...props}
  />
)

export default withConnectionQuery({
  graphqlQuery,
  paginated: true,
  namespace: 'users'
})(RoutePrimaryUserManage)



// WEBPACK FOOTER //
// ./src/routes/admin/companies/primary_user/manage.js